var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "div",
        { staticClass: "course-list child" },
        [
          _c("p", { staticClass: "nav", on: { click: _vm.toCourseList } }, [
            _c("span", { staticClass: "el-icon-arrow-left" }),
            _c("span", [_vm._v("返回")])
          ]),
          _vm._v(" "),
          _vm._l(_vm.courseList, function(c, key) {
            return _c("div", { staticClass: "step-list" }, [
              _c(
                "div",
                {
                  class: {
                    step: true,
                    active: c.passState == "Passed",
                    progress: c.passState == "Ongoing"
                  }
                },
                [
                  _c("div", {
                    class: {
                      icon: true,
                      "el-icon-success": c.passState == "Passed"
                    },
                    staticStyle: { top: "75px !important" }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "line",
                    staticStyle: { top: "92px !important" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content content_box" }, [
                _c("img", { attrs: { src: c.imageUrl } }),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "type" }, [
                          _vm._v(_vm._s(c.categoryName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(c.courseName))
                        ])
                      ]),
                      _vm._v(" "),
                      c.unlock
                        ? [
                            _c(
                              "div",
                              {
                                class: { cancel_botton: c.courseType != "Exam" }
                              },
                              [
                                c.courseType == "Exam" &&
                                c.passState != "Passed"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("开始测试")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.courseType == "Exam" &&
                                c.passState == "Passed"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("重新测试")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "state_posi",
                                    class:
                                      c.passState == "Passed" ? "green" : "red"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        c.passState == "Passed"
                                          ? "已完成"
                                          : "未完成"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                c.passState == "Passed" &&
                                c.courseType != "Exam" &&
                                c.passState != "Study"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "start_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("继续学习")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.passState != "Passed" &&
                                c.courseType != "Exam" &&
                                c.passState != "Study"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "start_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("开始学习")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        : [_c("div", { staticClass: "el-icon-lock" })]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text",
                      staticStyle: { height: "90px !important" }
                    },
                    [
                      _vm._v(
                        "\n            课程说明：" +
                          _vm._s(c.description) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("exam-dialog", {
        attrs: {
          visible: _vm.examVisible,
          id: _vm.id,
          courseId: _vm.examCourseId,
          tabMajorId: _vm.tabMajorId,
          majorId: _vm.majorId,
          type: _vm.type,
          isListPage: true,
          parent: "jineng"
        },
        on: { callback: _vm.closeDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc9f60b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc9f60b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/childCourseList.vue
// module id = 1606
// module chunks = 0